import React from "react";
import * as tmscall from '../common/restService/tmServices';
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList,MultiSelect } from '@progress/kendo-react-dropdowns';
//import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { Grid, GridColumn, GridToolbar as Column, GridDetailRow } from '@progress/kendo-react-grid';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { Window } from '@progress/kendo-react-dialogs';
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import '../IntelShipmentRequest/intelShip.css';
import {process} from '@progress/kendo-data-query';
import { count } from "@progress/kendo-data-query/dist/npm/array.operators";
import '../commonStyle/tmsStyle.scss';
//import dm from '../IntelShipmentRequest/demo.jsx';
import { filterBy } from '@progress/kendo-data-query';
import $, { event } from 'jquery';  
import { filter } from "@progress/kendo-data-query/dist/npm/transducers";
import {DateTimePicker} from '@progress/kendo-react-dateinputs';
import { withRouter } from "../NCRMSHome/withRouter";
import Loaders from '../Loaders';
import BlockUi from '@availity/block-ui';

const dataState={
    skip:0,
    sort:[],
    take:10,
}
class RequestAuthorized extends React.Component{ 
    constructor(props){
        super(props);
        this.state={carrierinfo:[],saveParentScac:[],dataState:dataState,checked:false,ReqAuthorlist:[],blocking:false, tor_id: null};
    }

componentDidMount(){
   
    this.setState({tor_id: decodeURI(this.props.location.pathname.split(":")[1])});
    this.state.ParentScac=this.props.location.state.parentscac.value; 
    this.state.CarrierCode=this.props.location.state.scacAbb;
this.getuserDetails();
this.F4_CARRIER_INFO();
}

getuserDetails(){  
    let profile = JSON.parse(sessionStorage.getItem('profile'));
    console.log("profile",profile);
}

async F4_CARRIER_INFO(){

    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_CARRIER_INFO";
    inputObj["Input"] = "";
    props.input = inputObj;    
    const CARRIER_INFO = await GatewayGet(props, props.input);    
    console.log("CARRIER_INFO",CARRIER_INFO);
    let filteredcarrierArray = [];
    let PrntScac=this.state.ParentScac;

    filteredcarrierArray = CARRIER_INFO.filter(function (entry) {
        
        return entry.scacd == PrntScac;

    });
    this.setState({carrierinfo:filteredcarrierArray});

    console.log("filter",filteredcarrierArray);
    //  var PD=[];
    // for(var i=0;i<CARRIER_INFO.length;i++){

    //        var obj={};
    //         obj.value=CARRIER_INFO[i].scacd;
    //         PD.push(obj);
        
    // }
    
    // this.state.saveParentScac.push(PD);
   
}

checkBoxClicked(data,e){
    this.state.checkedValue=e.target.checked;

if(e.target.checked==true){

     e.target.checked=true;
console.log(this.state.CarrierCode)
console.log(data.dataItem.contactEmail)

    //  this.state.ReqAuthorlist.push(data.dataItem);    
    this.state.ReqAuthorlist.push({"CARRIER":this.state.CarrierCode,"EMAIL_ID":data.dataItem.contactEmail});    

     if(this.state.ReqAuthorlist==1 || this.state.ReqAuthorlist==5){
         
        this.AuthSubmit();
     }  
    
     //this.state.selectedRowData.push(data.dataItem.TOR_ID)
 }
// else {
//     var toDel = this.state.ReqAuthorlist.indexOf(data.dataItem);
//     this.state.ReqAuthorlist.splice(toDel, 1);
//     e.target.checked=false;

// }
    

}
    
async AuthSubmit(){

if(this.state.checkedValue==true){    

 if(this.state.ReqAuthorlist.length>5)
 {        
     
    toast.error("Select Atleast 1 Contact or Max upto 5 contacts", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });

    this.setState({checked:false,ReqAuthorlist:[]});
    
        
    } else{

            let props = {};
            let inputObj = {};
            props["query"] = constants.serviceRoot;
            props["headers"] = constants.serviceHeaders;
            inputObj["Activity"]="F4_CARRIERS_SCAC";
            inputObj["Input"]="";
            props.input=inputObj;
            const result=await GatewayGet(props,props.input);
            //console.log(result);

            var scaclist=[];
    for(var i=0;i<result.length;i++){
           var obj={};
            obj.scacd=result[i].text;
            scaclist.push(obj);        
    }
   // console.log("hellllo",scaclist);
    //this.state.saveParentScac.push(PD);
            
            // let filteredcarrierArray = this.state.ReqAuthorlist.filter(function (entry) {
                
            //     var pscac=scaclist.scacd.includes(entry.scacd);
            //     console.log("pscac",pscac);
			// });

            // console.log("filteredcarrierArray",filteredcarrierArray);
       let jsondata={tor_id:this.state.tor_id,im_carrier_contact:this.state.ReqAuthorlist};
       this.AuthorupdateEmail(jsondata);
    }

 }else {

    
    toast.error("Select Atleast 1 Contact", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });


    this.setState({checked:false,ReqAuthorlist:[]});
 }

}

async AuthorupdateEmail(jsondata){
// BB user 
this.setState({blocking:true});
let InputJSONString=JSON.stringify(jsondata);
let props = {};
let inputObjs = {};
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;
inputObjs["Activity"] = "FO_UPDATE_CONTACT_EMAIL";
inputObjs["Input"] = InputJSONString;
props.input = inputObjs;
const result = await GatewayGet(props, props.input);

if(result.STATUS=="SUCCESS"){
    
    var successresult=result.MESSAGE;
    const success=successresult[0].MESSAGE + ","+ successresult[1].MESSAGE;
    toast.success(success, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });

        // BB User Fo_Submit 

        inputObjs["Activity"] = "FO_SUBMIT";
        const inputData = {
            "tor_id": this.state.tor_id
        };
        this.setState({blocking:true});
        InputJSONString = JSON.stringify(inputData);
        inputObjs["Input"] = InputJSONString;
        const result1 = await GatewayGet(props, props.input);

        if (result1['STATUS'] === "SUCCESS") {
            sessionStorage.setItem("tor_id", this.state.tor_id); 
            this.setState({checked:false,ReqAuthorlist:[]});  
            // redirect to request authorized
            this.props.navigate('/intelshipment',{ state: {isRequestAuthorized : true,tor_type : this.props.location.state.tor_type}})

        }
        
        else if(result1['STATUS'] === "FAILURE"){
            var msg=''; 
            sessionStorage.setItem("tor_id", this.state.tor_id); 
            this.setState({checked:false,ReqAuthorlist:[]});  
            if(result1['MESSAGE'][1].TYPE=='E')
            {
                msg = result1['MESSAGE'][1].MESSAGE;              

                toast.error(msg, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
             progress: undefined,
        theme:"colored"
                  });              

            }
            this.props.navigate('/intelshipment',{ state: {isRequestAuthorized : true,tor_type : this.props.location.state.tor_type}})

            this.setState({blocking:false});


        }

        this.setState({blocking:false});

}

}
    render(){

        
const grids = (

    <Grid
            ScrollMode="scrollable"
            width="100%"
            pageable
            sortable
            filterable
            data={process(this.state.carrierinfo, this.state.dataState)}
            {...this.state.dataState}
            onDataStateChange={(e) => {
                this.setState({ dataState: e.dataState })
            }}
            dataGrid="myGrid"
            dataBound={this.onDataBound}
            reorderable
            ref={(grid) => { this._grid = grid; }}
            >
{/* _checkboxtemplate = '', */}
<GridColumn filterable={false} field="" title="" width="50px"  
cell={props=>(<td><input type="checkbox" defaultChecked={this.state.checked} onChange= {this.checkBoxClicked.bind(this,props)} /></td>)}/>
<GridColumn field="geo" title="Location" width="150px"  filter="text" />
<GridColumn field="modeTransport" title="Mode" filter="text" width="150px"/>
<GridColumn field="segment" title="Segment" filter="text" width="150px"/>
<GridColumn field="contactName" title="Contact" filter="text" width="150px"/>
<GridColumn field="contactEmail" title="Contact Email" filter="text" width="150px"/>
</Grid>);

        return(<div>
            
            <BlockUi tag="div" blocking={this.state.blocking}
        
        loader={<Loaders />}>

{/* <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
/><ToastContainer /> */}

    <MDBContainer fluid style={{paddingLeft: "35px"}}>
    <MDBRow>
        <MDBCol sm="12"className="titleBox"><label>Request Authorize</label></MDBCol>
    </MDBRow>
</MDBContainer>

<MDBContainer fluid style={{paddingLeft: "35px"}}>
    <MDBRow>

         <p id="ptxt">Select at least one carrier contact - Max up to 5 contacts</p>
       
         </MDBRow>
    </MDBContainer>

<MDBContainer fluid style={{paddingLeft: "35px"}}>
    <MDBRow>
        <MDBCol>
            <div id="reqAut">
             {grids}
         </div>
        </MDBCol>
    </MDBRow>
</MDBContainer>


<MDBContainer fluid style={{paddingLeft: "35px"}}>
    <MDBRow>
        <MDBCol>
  <div className="form-group">  
        <span><button className="btn k-button k-button-icontext resbmt" onClick={this.AuthSubmit.bind(this)}>Submit</button></span>

          <span>
          <Link to="/NCRMHome"><button className="btn k-button k-button-icontext rejectbtn">Cancel</button></Link></span>       
      </div>
 
        </MDBCol>
        </MDBRow>
        </MDBContainer>
        </BlockUi>
        </div>);
    }

}
export default withRouter(RequestAuthorized);